/** Canonical ICP / app feature catalog keys (tenant_type_features.tenant_type) */
export const TENANT_TYPES = [
  {
    value: '',
    label: 'StepCare (default)',
    description: 'Care-staff web dashboard (tenants.type empty string)'
  },
  {
    value: 'volition',
    label: 'Volition',
    description: 'Volition ICP web shell (tenants.type = volition)'
  },
  {
    value: 'circle',
    label: 'Circle',
    description: 'Family app feature catalog (resolved from users.type at JWT time)'
  },
  {
    value: 'hub',
    label: 'StepCare Hub',
    description: 'Self-managed care workspace for AU NDIS / NZ Whaikaha (tenants.type = hub)'
  },
  {
    value: 'forms',
    label: 'StepCare Forms',
    description: 'Compliance-first AI voice forms shell (tenants.type = forms)'
  }
] as const

export type TenantTypeValue = (typeof TENANT_TYPES)[number]['value']

/** Mantine Tabs require non-empty `value`; map DB `''` (StepCare default) for UI controls. */
export const DEFAULT_TENANT_TYPE_TAB = '__default__'

export function tenantTypeToTabValue(type: string): string {
  return type === '' ? DEFAULT_TENANT_TYPE_TAB : type
}

export function tabValueToTenantType(tabValue: string): string {
  return tabValue === DEFAULT_TENANT_TYPE_TAB ? '' : tabValue
}

export function getTenantTypeLabel(type: string | null | undefined): string {
  const match = TENANT_TYPES.find((t) => t.value === (type ?? ''))
  return match?.label ?? type ?? 'Unknown'
}

export function tenantTypeSelectData() {
  return TENANT_TYPES.map((t) => ({
    value: t.value,
    label: t.label
  }))
}
